export const SkillsData = [
  {
    type: "Front-End",
    list: [
      {
        name: ".Net",
        icon: <i class="devicon-dotnetcore-plain colored"></i>
        },
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>
        },
      {
        name: "HTML5",
        icon: <i class="devicon-html5-plain colored"></i>
        },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>
      },
    ],
  },
  {
    type: "Back-End",
    list: [
      {
        name: "C#",
        icon: <i class="devicon-csharp-plain colored"></i>
        },
      {
        name: "Python",
        icon: <i class="devicon-python-plain colored"></i>
        },
      {
        name: "Php",
        icon: <i class="devicon-php-plain colored"></i>
        },
      {
        name: "C",
        icon: <i class="devicon-c-plain colored"></i>
      },
    ],
  },
  {
    type: "Other Skills",
    list: [
      {
        name: "Firebase",
        icon: <i class="devicon-firebase-plain colored"></i>
      },
      {
        name: "Bootstrap",
        icon: <i class="devicon-bootstrap-plain colored"></i>
      },
      {
        name: "Azure",
        icon: <i class="devicon-azure-plain colored"></i>
      },
      {
        name: "TailwindCSS",
        icon: <i class="devicon-tailwindcss-plain colored"></i>
      },
      {
        name: "Wordpress",
        icon: <i class="devicon-wordpress-plain colored"></i>
      },
      {
        name: "SPSS",
        icon: <i class="devicon-spss-plain colored"></i>
      },
      {
        name: "Sqlalchemy",
        icon: <i class="devicon-sqlalchemy-plain colored"></i>
      },
      {
        name: "SASS",
        icon: <i class="devicon-sass-plain colored"></i>
      },
      {
        name: "Github",
        icon: <i class="devicon-github-plain colored"></i>
      },
      {
        name: "Apache",
        icon: <i class="devicon-apache-plain colored"></i>
      },
    ],
  },
];